import React from "react";
import PropTypes from "prop-types";
import { CustomContainer } from "../DependencyHelper";
import LabelText from "../label/LabelText";
import Image from "../image/image";

import styles from "./InfoBox.module.scss";

const InfoBox = ({ className, type, text, imageSrc, imageWidth, imageHeight }) => {
  return (
    <CustomContainer className={`${styles["info-message"]} ${styles[type]} ${className}`}>
      {imageSrc &&
      <Image
        className={styles["info-message--img"]}
        img_path={imageSrc}
        img_width={imageWidth}
        img_height={imageHeight}
        img_alt={type || "icon"}
      />
      }
      <LabelText className={styles["info-message--label"]}>
        {text}
      </LabelText>
    </CustomContainer>
  );
};

InfoBox.defaultProps = {
  className: "info-message-default",
  type: "info",
  text: "",
  imageSrc: "",
  imageWidth: "1.3125rem",
  imageHeight: "1.3125rem"
};

InfoBox.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string,
  imageSrc: PropTypes.string,
  imageWidth: PropTypes.string,
  imageHeight: PropTypes.string,
};

export default InfoBox;
